import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { EditClinicPageStyled } from './EditClinicPageStyled';
import { EstadosBrasil } from '../../../main/constant/UfConstant';
import { Button, Card, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import ContainerSideBarComponent from '../../component/container/ContainerSidebarComponent';

import { TfiSave } from 'react-icons/tfi';
import { FaArrowLeft } from 'react-icons/fa';
import { PiIdentificationCard } from 'react-icons/pi';
import { IoLocationOutline, IoPersonCircleOutline } from 'react-icons/io5';

import { InputsClinic, PropsEditClinic } from './EditClinicPageType';
import AlertComponent from '../../component/alert/AlertComponent';
import { maskUtils } from '../../../main/helper/maskHelper';

const EditClinicPage: React.FC<PropsEditClinic> = ({ saveClinic, clinic, comeBack, getAddress, address }: PropsEditClinic) => {
  /** useForm */
  const {
    register,
    getValues,
    setValue,
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<InputsClinic>();

  /**
   * handleSaveClinic
   */
  const handleSaveClinic = async () => {
    const model = {
      id: getValues('id') ?? '',
      name: getValues('name') ?? '',
      status: getValues('status') ?? '',
      tradeName: getValues('tradeName') ?? '',
      accountType: getValues('accountType') ?? '',
      document_CNPJ: getValues('document_CNPJ') ?? '',
      document_CPF: getValues('document_CPF') ?? '',
      contact_Phone: getValues('contact_Phone') ?? '',
      contact_Email: getValues('contact_Email') ?? '',
      address_ZipCode: getValues('address_ZipCode') ?? '',
      address_Street: getValues('address_Street') ?? '',
      address_Number: getValues('address_Number') ?? '',
      address_Complement: getValues('address_Complement') ?? '',
      address_Neighborhood: getValues('address_Neighborhood') ?? '',
      address_City: getValues('address_City') ?? '',
      address_State: getValues('address_State') ?? '',
      address_Country: getValues('address_Country') ?? '',
      responsible_Name: getValues('responsible_Name') ?? '',
      responsible_Email: getValues('responsible_Email') ?? '',
      responsible_Document_CRO: getValues('responsible_Document_CRO') ?? '',
      responsible_Document_RG: getValues('responsible_Document_RG') ?? '',
      responsible_Document_RG_IssuingAuthority: getValues('responsible_Document_RG_IssuingAuthority') ?? '',
      setup_NumberOfChairs: getValues('setup_NumberOfChairs') ?? '',
      setup_DentistAdmin: getValues('setup_DentistAdmin') ?? '',
      setup_StandardAppointmentTime: getValues('setup_StandardAppointmentTime') ?? '',
      setup_WeeklyWorkingHours: getValues('setup_WeeklyWorkingHours') ?? '',
      setup_WeekDays: getValues('setup_WeekDays') ?? '',
    };

    await saveClinic(model);
  };

  /**
   * setModel
   * @param model
   */
  const setModel = (model: any) => {
    if (model !== null) {
      setValue('id', model.id);
      setValue('accountType', model.accountType);
      setValue('name', model.name ? model.name.trimEnd() : '');
      setValue('status', model.status);
      setValue('tradeName', model.tradeName ? model.tradeName.trimEnd() : '');
      setValue('accountType', model.accountType);
      setValue('document_CNPJ', model.document_CNPJ ? maskUtils.cnpj(model.document_CNPJ.trimEnd()) : '');
      setValue('document_CPF', model.document_CPF ? maskUtils.cpf(model.document_CPF.trimEnd()) : '');
      setValue('contact_Phone', model.contact_Phone ? maskUtils.celular(model.contact_Phone.trimEnd()) : '');
      setValue('contact_Email', model.contact_Email ? model.contact_Email.trimEnd() : '');
      setValue('address_ZipCode', model.address_ZipCode ? maskUtils.cep(model.address_ZipCode.trimEnd()) : '');
      setValue('address_Street', model.address_Street ? model.address_Street.trimEnd() : '');
      setValue('address_Number', model.address_Number ? model.address_Number.trimEnd() : '');
      setValue('address_Complement', model.address_Complement ? model.address_Complement.trimEnd() : '');
      setValue('address_Neighborhood', model.address_Neighborhood ? model.address_Neighborhood.trimEnd() : '');
      setValue('address_City', model.address_City ? model.address_City.trimEnd() : '');
      setValue('address_State', model.address_State);
      setValue('address_Country', model.address_Country);
      setValue('responsible_Name', model.responsible_Name ? model.responsible_Name.trimEnd() : '');
      setValue('responsible_Email', model.responsible_Email ? model.responsible_Email.trimEnd() : '');
      setValue('responsible_Document_CRO', model.responsible_Document_CRO ? model.responsible_Document_CRO.trimEnd() : '');
      setValue('responsible_Document_RG', model.responsible_Document_RG ? model.responsible_Document_RG.trimEnd() : '');
      setValue('responsible_Document_RG_IssuingAuthority', model.responsible_Document_RG_IssuingAuthority);
      setValue('setup_NumberOfChairs', model.setup_NumberOfChairs);
      setValue('setup_DentistAdmin', model.setup_DentistAdmin);
      setValue('setup_StandardAppointmentTime', model.setup_StandardAppointmentTime);
      setValue('setup_WeeklyWorkingHours', model.setup_WeeklyWorkingHours);
      setValue('setup_WeekDays', model.setup_WeekDays);
    }
  };

  /**
   * inicio
   */
  useEffect(() => {
    if (clinic !== null) {
      setModel(clinic);
    }
  }, [clinic]);

  /** Observando mudanças no accountType */
  const accountType = watch('accountType');

  /**
   * handleCepChange - busca o endereco pelo cep
   * @param cep
   */
  const handleCepChange = async (cep: string) => {
    const cepFormatado = maskUtils.cep(cep);
    if (cepFormatado.length === 9) {
      await getAddress(cepFormatado);
    }
  };

  /**
   * inicio
   */
  useEffect(() => {
    if (address !== null) {
      setValue('address_Street', address.street);
      setValue('address_Neighborhood', address.neighborhood);
      setValue('address_City', address.city);
      setValue('address_State', address.state);
    }
  }, [address]);

  /**
   * mostra modal
   */
  const [show, setShow] = useState(false);

  /**
   * handleClose - fecha modal
   */
  const handleClose = async () => {
    setShow(false);
  };

  /**
   * handleShow - abre modal
   */
  const handleShow = () => setShow(true);

  const handleUpgradeToPro = () => {
    console.log('handleUpgradeToPro');
  };

  return (
    <ContainerSideBarComponent>
      <AlertComponent />
      <EditClinicPageStyled>
        <Container fluid className="title-page">
          <h3>Clínica</h3>
        </Container>

        <Container fluid>
          <Card style={{ marginBottom: '40px' }}>
            <Card.Body>
              <Container fluid>
                <Form onSubmit={handleSubmit(handleSaveClinic)}>
                  <input type="hidden" id="id" {...register('id')} />
                  <input type="hidden" id="status" {...register('status')} />
                  <input type="hidden" id="accountType" {...register('accountType')} />

                  <div className="container-field">
                    <Row className="row-field">
                      <Col>
                        <Button
                          size="sm"
                          variant="warning"
                          style={{
                            float: 'right',
                            backgroundColor: '#ff9900',
                            color: '#fff',
                            fontWeight: 'bold',
                            padding: '5px 15px',
                            borderRadius: '8px',
                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                            marginLeft: '10px',
                            animation: 'pulse-button 2s infinite',
                          }}
                          onClick={handleShow}>
                          🚀 MIGRAR PARA O PRO
                        </Button>
                        <Button size="sm" style={{ float: 'right' }} type="submit">
                          <TfiSave width={30} style={{ paddingRight: '5px' }} />
                          Salvar
                        </Button>
                        <Button size="sm" variant="outline-primary" style={{ float: 'right', marginRight: '5px' }} onClick={comeBack}>
                          <FaArrowLeft width={30} style={{ paddingRight: '5px' }} />
                          Voltar
                        </Button>
                      </Col>
                    </Row>

                    <style type="text/css">
                      {`@keyframes pulse-button {
                          0% {
                            transform: scale(1);
                          }
                          50% {
                            transform: scale(1.05);
                          }
                          100% {
                            transform: scale(1);
                          }
                        }`}
                    </style>

                    <div className="title">
                      <PiIdentificationCard />
                      <h6>Cadastro da Clínica</h6>
                    </div>
                    <Row className="row-field">
                      <Col xs={12} sm={6}>
                        <Form.Label>Nome Fantasia</Form.Label>
                        <Form.Control placeholder="Nome Fantasia" {...register('tradeName', { required: 'campo obrigatório' })} />
                        {errors.tradeName && <span className="text-danger">{errors.tradeName.message}</span>}
                      </Col>
                      <Col xs={12} sm={6}>
                        <Form.Label>Nome da Clínica</Form.Label>
                        <Form.Control placeholder="Nome da Clínica" {...register('name', { required: 'campo obrigatório' })} />
                        {errors.name && <span className="text-danger">{errors.name.message}</span>}
                      </Col>
                      {accountType === 'F' && (
                        <Col sm={3}>
                          <Form.Label>CPF</Form.Label>
                          <Controller
                            control={control}
                            name="document_CPF"
                            rules={{ required: 'campo obrigatório' }}
                            render={({ field }) => (
                              <Form.Control {...field} placeholder="CNPJ" onChange={(e) => field.onChange(maskUtils.cpf(e.target.value))} />
                            )}
                          />
                          {errors.document_CPF && <span className="text-danger">{errors.document_CPF.message}</span>}
                        </Col>
                      )}
                      {accountType === 'J' && (
                        <Col sm={3}>
                          <Form.Label>CNPJ</Form.Label>
                          <Controller
                            control={control}
                            name="document_CNPJ"
                            rules={{ required: 'campo obrigatório' }}
                            render={({ field }) => (
                              <Form.Control {...field} placeholder="CNPJ" onChange={(e) => field.onChange(maskUtils.cnpj(e.target.value))} />
                            )}
                          />
                          {errors.document_CNPJ && <span className="text-danger">{errors.document_CNPJ.message}</span>}
                        </Col>
                      )}
                    </Row>
                    <Row className="row-field">
                      <Col xs={12} sm={6}>
                        <Form.Label>Email</Form.Label>
                        <Form.Control placeholder="Email" {...register('contact_Email', { required: 'campo obrigatório' })} />
                        {errors.contact_Email && <span className="text-danger">{errors.contact_Email.message}</span>}
                      </Col>
                      <Col xs={12} sm={6}>
                        <Form.Label>CRO responsável</Form.Label>
                        <Form.Control placeholder="CRO responsável" {...register('responsible_Document_CRO', { required: 'campo obrigatório' })} />
                        {errors.responsible_Document_CRO && <span className="text-danger">{errors.responsible_Document_CRO.message}</span>}
                      </Col>
                      <Col sm={3}>
                        <Form.Label>Telefone</Form.Label>
                        <Controller
                          control={control}
                          name="contact_Phone"
                          rules={{ required: 'campo obrigatório' }}
                          render={({ field }) => (
                            <Form.Control {...field} placeholder="Telefone" onChange={(e) => field.onChange(maskUtils.celular(e.target.value))} />
                          )}
                        />
                        {errors.contact_Phone && <span className="text-danger">{errors.contact_Phone.message}</span>}
                      </Col>
                    </Row>
                  </div>
                  <div className="container-field">
                    <div className="title">
                      <IoLocationOutline />
                      <h6>Endereço</h6>
                    </div>
                    <div>
                      <Row className="row-field">
                        <Col sm={3}>
                          <Form.Label>Cep</Form.Label>
                          <Controller
                            control={control}
                            name="address_ZipCode"
                            rules={{ required: 'campo obrigatório' }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                placeholder="Cep"
                                onChange={(e) => {
                                  const cepComMascara = maskUtils.cep(e.target.value);
                                  field.onChange(cepComMascara);
                                  handleCepChange(cepComMascara);
                                }}
                              />
                            )}
                          />
                          {errors.address_ZipCode && <span className="text-danger">{errors.address_ZipCode.message}</span>}
                        </Col>
                        <Col>
                          <Form.Label>Endereço</Form.Label>
                          <Form.Control placeholder="Endereço" {...register('address_Street', { required: 'campo obrigatório' })} />
                          {errors.address_Street && <span className="text-danger">{errors.address_Street.message}</span>}
                        </Col>
                      </Row>
                      <Row className="row-field">
                        <Col>
                          <Form.Label>Número</Form.Label>
                          <Form.Control placeholder="Número" {...register('address_Number')} />
                        </Col>
                        <Col>
                          <Form.Label>Complemento</Form.Label>
                          <Form.Control placeholder="Complemento" {...register('address_Complement')} />
                        </Col>
                        <Col>
                          <Form.Label>Bairro</Form.Label>
                          <Form.Control placeholder="Bairro" {...register('address_Neighborhood', { required: 'campo obrigatório' })} />
                          {errors.address_Neighborhood && <span className="text-danger">{errors.address_Neighborhood.message}</span>}
                        </Col>
                        <Col>
                          <Form.Label>Cidade</Form.Label>
                          <Form.Control placeholder="Cidade" {...register('address_City', { required: 'campo obrigatório' })} />
                          {errors.address_City && <span className="text-danger">{errors.address_City.message}</span>}
                        </Col>
                        <Col>
                          <Form.Label>Estado</Form.Label>
                          <Form.Select aria-label="UF" {...register('address_State', { required: 'campo obrigatório' })}>
                            <option>Selecione a UF</option>
                            {EstadosBrasil.map((item) => {
                              return (
                                <option key={item.sigla} value={item.sigla}>
                                  {item.nome}
                                </option>
                              );
                            })}
                          </Form.Select>
                          {errors.address_State && <span className="text-danger">{errors.address_State.message}</span>}
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="container-field">
                    <div className="title">
                      <IoPersonCircleOutline />
                      <h6>Gestor administrador da clínica</h6>
                    </div>
                    <div>
                      <Row className="row-field">
                        <Col sm={5}>
                          <Form.Label>Nome</Form.Label>
                          <Form.Control placeholder="Nome" {...register('responsible_Name', { required: 'campo obrigatório' })} />
                          {errors.responsible_Name && <span className="text-danger">{errors.responsible_Name.message}</span>}
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="container-field">
                    <div className="title">
                      <IoPersonCircleOutline />
                      <h6>Configuração da clínica</h6>
                    </div>
                    <div>
                      <Row className="row-field">
                        <Col sm={2}>
                          <Form.Label>Quantidade de cadeiras</Form.Label>
                          <Form.Control placeholder="Quantidade de cadeiras" {...register('setup_NumberOfChairs', { required: 'campo obrigatório' })} />
                          {errors.setup_NumberOfChairs && <span className="text-danger">{errors.setup_NumberOfChairs.message}</span>}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Form>
              </Container>
            </Card.Body>
          </Card>
        </Container>
        <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered className="upgrade-modal">
          <Modal.Header closeButton>
            <Modal.Title style={{ fontWeight: 'bold', color: '#9459d0', textTransform: 'uppercase', letterSpacing: '1px' }}>
              🎉 Parabéns pelo Upgrade!
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <h4 style={{ color: '#555' }}>Você está a um passo de liberar todos os recursos do nosso plano PRO!</h4>
              <p style={{ fontSize: '16px', color: '#777', margin: '20px 0' }}>
                Entre em contato com <span style={{ fontWeight: 'bold', color: '#9459d0' }}>atendimento@lumegrupo.com.br</span> para realizar a migração!
              </p>
              {/*<p style={{ fontSize: '16px', color: '#777', margin: '20px 0' }}>*/}
              {/*  Ao fazer o upgrade, você terá acesso a funcionalidades exclusivas, suporte prioritário e muito mais. Aproveite ao máximo sua experiência!*/}
              {/*</p>*/}
              {/*<div style={{ padding: '20px', backgroundColor: '#f1f1f1', borderRadius: '10px' }}>*/}
              {/*  <h5 style={{ marginBottom: '10px' }}>Benefícios do Plano PRO:</h5>*/}
              {/*  <ul style={{ listStyleType: 'none', padding: '0', lineHeight: '2' }}>*/}
              {/*    <li>✅ Acesso ilimitado a todas as funcionalidades</li>*/}
              {/*    <li>✅ Suporte prioritário com tempo de resposta reduzido</li>*/}
              {/*    <li>✅ Atualizações exclusivas antes de todos</li>*/}
              {/*    <li>✅ Muito mais vantagens incríveis</li>*/}
              {/*  </ul>*/}
              {/*</div>*/}
            </div>
          </Modal.Body>
          <Modal.Footer style={{ display: 'flex', justifyContent: 'center' }}>
            {/*<Button*/}
            {/*  size="sm"*/}
            {/*  variant="success"*/}
            {/*  style={{*/}
            {/*    backgroundColor: '#9459d0',*/}
            {/*    border: 'none',*/}
            {/*    padding: '10px 20px',*/}
            {/*    fontWeight: 'bold',*/}
            {/*    animation: 'pulse 2s infinite',*/}
            {/*  }}*/}
            {/*  onClick={handleUpgradeToPro}>*/}
            {/*  🚀 Fazer o Upgrade Agora!*/}
            {/*</Button>*/}
          </Modal.Footer>

          <style type="text/css">
            {`@keyframes pulse {
                0% {
                  transform: scale(1);
                }
                50% {
                  transform: scale(1.05);
                }
                100% {
                  transform: scale(1);
                }
              }
        
              .upgrade-modal .modal-content {
                background-image: linear-gradient(to right, #ffffff, #f0f0f0);
                box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
              }
        
              .upgrade-modal .modal-header {
                background-color: #9459d0;
                color: white;
                border-bottom: none;
              }
        
              .upgrade-modal .modal-footer {
                border-top: none;
              }`}
          </style>
        </Modal>
      </EditClinicPageStyled>
    </ContainerSideBarComponent>
  );
};

export default EditClinicPage;
